const directionPageArr = [
  { 
      page: "global",
      menu: 'userMenu',
      header: 'userHeader',
      footer: 'globalFooter'
  },
  {
      page: "HomePage",
      menu: false
  },
  {
      page: "UsersSignIn",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "UsersLogin",
      menu: false
  },
  {
      page: "UsersForgotPassword",
      menu: false
  },
  {
      page: "UsersHome",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "UsersList",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "UsersDetail",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "UsersUpdate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "UsersSearch",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TosPage",
      menu: "questMenu"
  },
  {
      page: "PrivacyPage",
      menu: "questMenu"
  },
  {
      page: "CookiePolicyPage",
      menu: "questMenu"
  },
  {
      page: "ErrorPage",
      menu: false
  },
  {
      page: "Error404",
      menu: false
  },
  {
      page: "TasksPublicHome",
      menu: "questMenu"
  },
  {
      page: "TasksPublicList",
      menu: "questMenu"
  },
  {
      page: "TasksPublicDetail",
      menu: "questMenu"
  },
  {
      page: "TasksPublicSearch",
      menu: "questMenu"
  },
  {
      page: "TasksHome",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksCreate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksUpdate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksDetail",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksList",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksSearch",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "CalendarView",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "ContactsHome",
      menu: "contactsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "ContactsCreate",
      menu: "contactsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "ContactsUpdate",
      menu: "contactsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "ContactsDetail",
      menu: "contactsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "ContactsList",
      menu: "contactsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "ContactsSearch",
      menu: "contactsMenu",
      header: "userHeader",
      footer: "globalFooter"
  }
];

export default directionPageArr;
